// Static wardrobe product catalog removed — products come from WooCommerce (dynamic REST).
// Colors come from App Configuration (dynamic REST).

export const wardrobeTextures = [];
export const wardrobeDesigns = [];
